import { baseApi } from './baseApi';

export const depositReconcileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Totals per reconcile outcome (dry run or live)
    getReconcileSummary: builder.query({
      query: () => '/deposit-reconcile/summary',
      providesTags: ['ReconcileSummary'],
    }),

    // Deposits the reconciler checked, with pagination and outcome filter
    getReconcileDeposits: builder.query({
      query: (params) => ({
        url: '/deposit-reconcile/deposits',
        params,
      }),
      providesTags: ['ReconcileDeposits'],
    }),
  }),
});

export const {
  useGetReconcileSummaryQuery,
  useGetReconcileDepositsQuery,
} = depositReconcileApi;
